






































































































































































































import { Component, Mixins, Watch, Vue } from 'vue-property-decorator'
import AbpBase from '@/lib/abpbase'
import OrderApi from '@/api/order/list'
import ShippingCompany from '@/api/shipping/index'

@Component({
  components: {}
})
export default class DeliverGood extends AbpBase {
  goodColumns: any[] = [
    // {
    //   type: 'selection',
    //   width: 60,
    //   align: 'center'
    // },
    {
      title: '商品图片',
      slot: 'pictureUrl',
      align: 'center'
    },
    {
      title: '商品名称',
      slot: 'productName',
      align: 'center'
    },
    {
      title: '价格/货号',
      slot: 'price',
      align: 'center'
    },
    {
      title: '属性',
      key: 'skuName',
      align: 'center'
    },
    {
      title: '数量',
      key: 'quantity',
      align: 'center'
    },
    {
      title: '包裹名',
      key: 'packages',
      align: 'center'
    },
    {
      title: '小计',
      slot: 'subTotal',
      align: 'center'
    }
  ]
  packagesColumns: any[] = [
    {
      title: '包裹名',
      key: 'packageName',
      align: 'center'
    },
    {
      title: '快递公司名称',
      slot: 'expressCompanyName',
      align: 'center'
    },
    {
      title: '快递单号',
      slot: 'shipmentNumber',
      align: 'center'
    },
    // {
    //   title: '发货时间',
    //   slot: 'deliveryTime',
    //   align: 'center'
    // },
    {
      title: '操作',
      slot: 'action',
      align: 'center'
    }
  ]
  loading: boolean = false
  loadBtn = false
  shipmentList: any[] = []
  expressCompanyName = null
  shipmentNumber = null
  orderDetail: any = {
    orderItems: [],
    expressPackages: []
  }

  get orderItems() {
    return this.orderDetail.orderItems ? this.orderDetail.orderItems : []
  }

  get expressPackages() {
    return this.orderDetail.expressPackages
      ? this.orderDetail.expressPackages
      : []
  }

  created() {
    this.getShippingCompanyList()
    this.getOrderDetail()
  }

  /**
   * 获取物流公司列表
   */
  getShippingCompanyList() {
    ShippingCompany.getShippingCompanyList().then(res => {
      this.shipmentList = res.data.items
    })
  }

  /**
   * 订单详情
   */
  getOrderDetail() {
    this.expressCompanyName = null
    this.shipmentNumber = null
    let id = this.$route.query['id'].toString()
    OrderApi.orderDetail(id).then(res => {
      res.data.expressPackages.forEach(item => {
        res.data.orderItems.forEach(child => {
          if (item.orderItemIdArray.indexOf(child.id) > -1) {
            child['packages'] = item.packageName
            child['_disabled'] = true
          }
        })
      })
      this.orderDetail = res.data
    })
  }

  /**
   * 发货
   */
  submit() {
    let vm = this
    let selection = (this.$refs.selection as any).getSelection()
    if (selection.length) {
      if (!vm.expressCompanyName) {
        this.$Notice.warning({
          desc: '请选择快递公司'
        })
        return true
      }
      if (!vm.shipmentNumber) {
        this.$Notice.warning({
          desc: '请输入快递单号'
        })
        return true
      }
      vm.loadBtn = true
      let list = selection
        .map(item => {
          return item.id
        })
        .join(',')
      let orderId = this.$route.query['id'].toString()
      OrderApi.updateShipment(
        orderId,
        list,
        vm.expressCompanyName,
        vm.shipmentNumber
      )
        .then(res => {
          this.loadBtn = false
          this.$Notice.success({
            desc: '发货成功'
          })
          this.getOrderDetail()
        })
        .catch(err => {
          this.loadBtn = false
        })
    } else {
      this.$Notice.warning({
        desc: '请先选择打包商品'
      })
    }
  }
  /**
   * 更新包裹快递信息
   */
  updatePackages(row) {
    if (!row.expressCompanyName) {
      this.$Modal.error({
        title: '请选择快递公司'
      })
      return
    }
    if (!row.shipmentNumber) {
      this.$Modal.error({
        title: '请输入快递单号'
      })
      return
    }
    let orderId = this.$route.query['id'].toString()
    this.$Modal.confirm({
      title: '提示',
      content: `确认发货？`,
      onOk: () => {
        OrderApi.shipmentNoExpressPackage(
          orderId,
          row.id,
          row.expressCompanyName,
          row.shipmentNumber
        ).then(res => {
          this.$Notice.success({ desc: '发货成功' })
          this.getOrderDetail()
        })
      }
    })
  }
}
